import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { AngularMaterialCommonModule } from '@app/shared/angular-material/angular-material-common.module';
import { NavigationItem } from '@app/shared/components/navigation/navigation-components.model';
import { NavigationComponentsService } from '@app/shared/components/navigation/navigation-components.service';

import { floatingMenuAnimation } from '../floating-menu.constants';

@Component({
  selector: 'app-mobile-bottom-navigation-floating-profile',
  templateUrl: './mobile-bottom-navigation-floating-profile.component.html',
  styleUrl: './mobile-bottom-navigation-floating-profile.component.scss',
  animations: [floatingMenuAnimation],
  imports: [CommonModule, AngularMaterialCommonModule]
})
export class MobileBottomNavigationFloatingProfileComponent {
  @Input({ required: true }) isVisible: boolean;
  @Output() onClose = new EventEmitter<void>();

  constructor(
    private navigationComponentsService: NavigationComponentsService
  ) {}

  get profileMenuItems$() {
    return this.navigationComponentsService.profileMenuItems$.asObservable();
  }

  handleProfileNavigationItemAction(item: NavigationItem) {
    this.onClose.emit();
    this.navigationComponentsService.handleProfileNavigationItemAction(item);
  }
}
